import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { getComponentDisplayName } from '../util/getComponentDisplayName';
import { useFormContext } from './FormWithValidation';
export function useInputContext(params) {
  var _ref, _params$forceShowVali;
  var formContext = useFormContext();
  var forceShowValidation = (_ref = (_params$forceShowVali = params.forceShowValidation) !== null && _params$forceShowVali !== void 0 ? _params$forceShowVali : formContext.forceShowValidation) !== null && _ref !== void 0 ? _ref : false;
  var previousForceValidation = usePrevious(forceShowValidation);
  var _React$useState = React.useState(forceShowValidation),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDirty = _React$useState2[0],
    setDirty = _React$useState2[1];
  React.useEffect(function () {
    var hasChanged = forceShowValidation !== previousForceValidation;
    var shouldChange = isDirty !== forceShowValidation;
    if (hasChanged && shouldChange) {
      setDirty(forceShowValidation);
    }
  }, [forceShowValidation, isDirty, previousForceValidation]);
  function makeDirty() {
    if (!isDirty) {
      setDirty(true);
    }
  }
  return _objectSpread({
    isDirty: isDirty,
    makeDirty: makeDirty
  }, formContext);
}
function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}

/** @deprecated */
export function withInputContextLegacyDeprecated(Component) {
  function InputWrapper(props) {
    var inputContext = useInputContext({
      forceShowValidation: props.forceShowValidation
    });
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, inputContext));
  }
  InputWrapper.displayName = getComponentDisplayName(Component);
  return InputWrapper;
}
export function withInputContext(Component) {
  function InputWrapper(props) {
    var inputContext = useInputContext({
      forceShowValidation: props.forceShowValidation
    });
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      inputContext: inputContext
    }));
  }
  InputWrapper.displayName = getComponentDisplayName(Component);
  return InputWrapper;
}